import { render, staticRenderFns } from "./UsersCardsItemOptionsButton.vue?vue&type=template&id=71e5485b"
import script from "./UsersCardsItemOptionsButton.vue?vue&type=script&lang=ts"
export * from "./UsersCardsItemOptionsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports